export const UTLConstants = {
    POST_UTL_GET_LABELS_REQUEST: 'POST_UTL_GET_LABELS_REQUEST',
    POST_UTL_GET_LABELS_SUCCESS: 'POST_UTL_GET_LABELS_SUCCESS',
    POST_UTL_GET_LABELS_ERROR: 'POST_UTL_GET_LABELS_ERROR',
};